import { Directive, Input, } from '@angular/core';
import { isAbsoluteUrl } from '@sitecore-jss/sitecore-jss/utils';
import { LinkDirective } from './link.directive';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class GenericLinkDirective extends LinkDirective {
    router;
    editable = true;
    attrs = {};
    field;
    extras;
    constructor(viewContainer, templateRef, renderer, elementRef, router) {
        super(viewContainer, templateRef, renderer, elementRef);
        this.router = router;
    }
    renderTemplate(props, linkText) {
        const viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
        viewRef.rootNodes.forEach((node) => {
            Object.entries(props).forEach(([key, propValue]) => {
                if (key === 'href' && !isAbsoluteUrl(propValue)) {
                    const fragments = propValue.split('#');
                    const url = fragments[0];
                    const anchor = fragments[1];
                    const urlTree = this.router.createUrlTree([url], {
                        fragment: anchor,
                        ...this.extras,
                    });
                    this.updateAttribute(node, key, this.router.serializeUrl(urlTree));
                    this.renderer.listen(node, 'click', (event) => {
                        this.router.navigate([url], {
                            fragment: anchor,
                            ...this.extras,
                        });
                        // shouldn't prevent default if the link includes a fragment
                        if (!anchor) {
                            event.preventDefault();
                        }
                    });
                }
                else {
                    this.updateAttribute(node, key, propValue);
                }
            });
            if (node.childNodes && node.childNodes.length === 0 && linkText) {
                node.textContent = linkText;
            }
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GenericLinkDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.TemplateRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: GenericLinkDirective, selector: "[scGenericLink]", inputs: { editable: ["scGenericLinkEditable", "editable"], attrs: ["scGenericLinkAttrs", "attrs"], field: ["scGenericLink", "field"], extras: ["scGenericLinkExtras", "extras"] }, usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GenericLinkDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[scGenericLink]' }]
        }], ctorParameters: () => [{ type: i0.ViewContainerRef }, { type: i0.TemplateRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i1.Router }], propDecorators: { editable: [{
                type: Input,
                args: ['scGenericLinkEditable']
            }], attrs: [{
                type: Input,
                args: ['scGenericLinkAttrs']
            }], field: [{
                type: Input,
                args: ['scGenericLink']
            }], extras: [{
                type: Input,
                args: ['scGenericLinkExtras']
            }] } });
